export const SeasonTabs = ({ seasons, active, onChange, testId = "season-tabs" }) => {
  if (seasons.length <= 1) return null;
  return (
    <div data-testid={testId} className="flex flex-wrap items-center gap-2">
      {seasons.map((s) => (
        <button key={s} data-testid={`season-tab-${s}`} data-active={active === s} onClick={() => onChange(s)} className="kp-pill">
          Season {s}
        </button>
      ))}
    </div>
  );
};

export const groupSeasons = (episodes) => [...new Set(episodes.map((e) => e.season || 1))].sort((a, b) => a - b);
